import { create } from "zustand";
import { UserAssignment } from "../interfaces/UserAssignment";

type UserAssignmentGridStore = {
    selectedUserAssignment: UserAssignment | null;
    setSelectedUserAssignment: (userAssignment: UserAssignment) => void;
    clearSelectedUserAssignment: () => void;
}

export const useUserAssignmentGridStore = create<UserAssignmentGridStore>((set) => ({
    selectedUserAssignment: null,
    setSelectedUserAssignment: (userAssignment) => set({ selectedUserAssignment: userAssignment }),
    clearSelectedUserAssignment: () => set({ selectedUserAssignment: null }),
}));